module.exports = __webpack_public_path__ + "static/media/blog-hai-doors@2x.b6f4c49a.jpg";